const commaList = (array: string[]): string => {
  const last = array.pop()
  if (array.length === 0) return last

  let result = array.join(", ")
  if (array.length > 1) result = result + ","
  return result + " and " + last
}

export default commaList
